// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"76927d81","977":"6aa6fd82"}[chunkId] + ".chunk.js";
};